module.exports = __webpack_public_path__ + "img/Sign_366.f6935c50.png";